(function () {
  var desktop = window.matchMedia('(min-width: 990px)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  function r3(x) {
    return Math.round(x * 1000) / 1000;
  }

  function init(root) {
    if (root.dataset.cdiInit) return;
    root.dataset.cdiInit = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cdi-dv-feat-card]'));
    var n = cards.length;
    if (n < 2) return;
    var weight = parseFloat(root.dataset.weight) || 3.2;
    var gap = parseFloat(root.dataset.gap) || 12;
    var total = weight + n - 1;
    var gaps = (n - 1) * gap;
    var active = 0;
    var hoverTimer = 0;

    function geometry(k) {
      var start = 0;
      cards.forEach(function (card, i) {
        var w = i === k ? weight : 1;
        var rest = total - start - w;
        var lp = r3((start * 100) / total);
        var lq = r3(i * gap - (gaps * start) / total);
        var rp = r3((rest * 100) / total);
        var rq = r3((n - 1 - i) * gap - (gaps * rest) / total);
        var f = (start + w / 2 - weight / 2) / total;
        var cp = r3(f * 100);
        var cq = r3(i * gap - gaps * f);
        card.style.setProperty('--l', 'calc(' + lp + '% + ' + lq + 'px)');
        card.style.setProperty('--r', 'calc(' + rp + '% + ' + rq + 'px)');
        card.style.setProperty('--c', 'calc(' + cp + 'cqi + ' + cq + 'px)');
        start += w;
      });
    }

    function activate(k) {
      if (k === active) return;
      active = k;
      geometry(k);
      cards.forEach(function (card, i) {
        var on = i === k;
        card.classList.toggle('is-active', on);
        var hit = card.querySelector('[data-cdi-dv-feat-hit]');
        if (hit) hit.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }

    cards.forEach(function (card, i) {
      var hit = card.querySelector('[data-cdi-dv-feat-hit]');
      if (hit) {
        hit.addEventListener('click', function () {
          clearTimeout(hoverTimer);
          activate(i);
        });
        hit.addEventListener('focus', function () {
          if (desktop.matches) activate(i);
        });
      }
      card.addEventListener('pointerenter', function () {
        if (!desktop.matches || !finePointer.matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () {
          activate(i);
        }, 110);
      });
      card.addEventListener('pointerleave', function () {
        clearTimeout(hoverTimer);
      });
    });
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-cdi-dv-feat]'), init);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-cdi-dv-feat]');
    if (root) init(root);
  });
})();
